/**
 * Featured Developers — sirf GitHub login likho (order = display order).
 * App start par har login ke liye GET /users/:login se id, avatar_url, html_url fetch hota hai.
 */
export const FEATURED_DEVELOPER_LOGINS = [
  "adnan2188",
  "octocat",
  "torvalds",
  "gaearon",
  "yyx990803",
  "rauchg",
  "jashkenas",
  "fat",
  "tpope",
  "sindresorhus",
  "mojombo",
  "defunkt",
  "pjhyett",
  "wycats",
  "matz",
  "dhh",
  "substack",
  "isaacs",
  "Alex313031",
];
